import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, LayoutDashboard, ClipboardList, ClipboardCheck, Bell, Users, Building2, ShieldPlus, LogOut, ShieldCheck, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { roleLabel } from "@/lib/format";

export default function MobileNav() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const isAdmin = user?.role === "administrator";
  const hasPro = user && (isAdmin || user.role === "manager" || user.pro_access);
  const link = ({ isActive }) => "sidebar-link" + (isActive ? " active" : "");
  const close = () => setOpen(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="lg:hidden fixed top-3 left-3 z-40 p-2 rounded-md bg-white shadow border border-slate-200"
        data-testid="mobile-menu-open"
        aria-label="Open navigation"
      >
        <Menu className="w-5 h-5 text-slate-700" />
      </button>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex" onClick={close}>
          <div className="absolute inset-0 bg-black/40" />
          <aside
            className="relative w-64 h-full bg-[#0F172A] text-slate-100 flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-5 pt-6 pb-4 border-b border-slate-800/70 flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center">
                  <ShieldCheck className="w-4 h-4 text-white" />
                </div>
                <div className="font-display font-extrabold">Complio</div>
              </div>
              <button onClick={close} className="p-1 text-slate-300" data-testid="mobile-menu-close">
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="flex-1 px-3 py-4 space-y-1" onClick={close}>
              <NavLink to="/dashboard" className={link}><LayoutDashboard className="w-4 h-4" /> Dashboard</NavLink>
              <NavLink to="/compliances" className={link}><ClipboardList className="w-4 h-4" /> VAT and Accounting</NavLink>
              <NavLink to="/excise" className={link}><ClipboardList className="w-4 h-4" /> Excise</NavLink>
              {hasPro && <NavLink to="/pro-compliances" className={link}><ShieldPlus className="w-4 h-4" /> PRO Compliance</NavLink>}
              <NavLink to="/audit-compliance" className={link}><ClipboardCheck className="w-4 h-4" /> Audit and Other Compliance</NavLink>
              <NavLink to="/corporate-tax" className={link}><ClipboardCheck className="w-4 h-4" /> Corporate Tax</NavLink>
              <NavLink to="/clients" className={link}><Building2 className="w-4 h-4" /> Client Master</NavLink>
              <NavLink to="/reminders" className={link}><Bell className="w-4 h-4" /> Reminders</NavLink>
              {isAdmin && <NavLink to="/users" className={link}><Users className="w-4 h-4" /> Users</NavLink>}
            </nav>
            <div className="px-3 pb-4">
              <div className="rounded-lg bg-slate-800/50 px-3 py-3 mb-2 text-xs">
                <div className="uppercase tracking-widest text-slate-400">Signed in</div>
                <div className="mt-1 font-medium truncate">{user?.name}</div>
                <div className="text-slate-400 mt-0.5">{roleLabel(user?.role)}</div>
              </div>
              <button onClick={logout} className="sidebar-link w-full text-left">
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
